export default {
  // 功能扩展参数：支持表格上方 - 配置 查询条件
  queryGroupUrl: {
    type: String,
    default: '',
  },
  // 功能扩展参数：支持表格上方 - 配置 顶部搜索框【默认显示】
  showOfSearchInput: {
    type: Boolean,
    default: true,
  },
  domTransfer: {
    type: String,
    default: '#routerView',
  },
  idPrefix: {
    type: String,
    default: 'keywordOfModalTable',
  },
  sideModalWidth: {
    type: [String, Number],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  value: {
    type: [Object, Array, String],
    //  default:()=>{  return {id:null,code:null,name:null}  }
  },

  requestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  requestParam: {
    type: [String, Object],
    default: null,
  },
  sideAddKey: {
    type: String,
    default: 'id',
  },
  searchKey: {
    type: String,
    default: 'keyword',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '关键字',
  },

  url: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '选择',
  },
  title: {
    type: String,
    default: '选择',
  },
  showModal: {
    type: Boolean,
    default: false,
  },
  clickRow: {
    type: Function,
  },
  field: {
    type: String,
    default: '',
  },
  showKey: {
    type: String,
    default: 'name',
  },
  selectPrams: {
    type: Object,
    default: () => {
      return {
        url: '',
        prams: {},
        pramsKey: null,
        pramsVal: null,
        methods: 'get',
        pramsType: 'string',
      }
    },
  },
  topToolTipInfo: {
    // 用于在顶部提示信息
    type: Object,
    default: () => {
      return {
        show: false,
        content: '',
      }
    },
  },

  // 自动关闭侧滑
  autoClosed: {
    type: Boolean,
    default: false,
  },
  // 显示加号得添加符
  iconSelection: {
    type: Boolean,
    default: true,
  },
  // 功能扩展参数：支持表格 - 配置 列定义url
  tableColumnDefUrl: {
    type: String,
    default: '',
  },
  tableColumnDef: {
    type: Array,
  },
  requestTagsObject: {
    type: Object,
    default: () => {
      return {
        url: '',
        params: {},
        methods: 'post',
      }
    },
  },
  openSelectedArr: {
    type: Boolean,
    default: true,
  },
  ifStopPropagation: {
    type: Boolean,
    default: false,
  },
  store: {
    type: Object,
    default: null,
  },
  pageSizeOption: {
    type: Array,
    default: () => [10, 20, 30, 40],
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  hideFooterBtn: { type: Boolean, default: true },
}
